import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/mini-css-extract-plugin/dist/loader.js??ref--8-oneOf-3-0!../../node_modules/css-loader/dist/cjs.js??ref--8-oneOf-3-1!../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-3-2!../../node_modules/sass-loader/dist/cjs.js??ref--8-oneOf-3-3!./bootstrap-theme-light.scss";

var options = {"injectType":"styleTag","attributes":{"data-theme":"theme-light"}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};